module.exports = __webpack_public_path__ + "img/anna-ungureanu.5875c557.png";